export default __webpack_public_path__ + "static/media/ustav_en.f2bbd779.jpg";